"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rotateBoard = rotateBoard;
const position_1 = require("./position");
const rotateGridPosition_1 = require("./rotateGridPosition");
function rotateBoard(board) {
    const newPositions = board.getAllPieces().map(({ id, x, y }) => {
        const newPos = (0, rotateGridPosition_1.rotateGridPosition)({ width: board.width, height: board.height }, (0, position_1.packPosition)(x, y));
        return { id, x: (0, position_1.unpackX)(newPos), y: (0, position_1.unpackY)(newPos) };
    });
    board.clear();
    for (const { id, x, y } of newPositions) {
        board.setPiece(id, x, y);
    }
}
